function lowerCaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1)
}

//mapping objects from WS as they come with First leter uppercase in comparison to HTTP response
export const objectKeysFirstLetterToLowerCase = function (input) {
    if (typeof input !== 'object') return input
    if (Array.isArray(input)) return input.map(objectKeysFirstLetterToLowerCase)
    return Object.keys(input).reduce(function (newObj, key) {
        const val = input[key]
        const newVal = typeof val === 'object' && val !== null ? objectKeysFirstLetterToLowerCase(val) : val
        newObj[lowerCaseFirstLetter(key)] = newVal
        return newObj
    }, {})
}
